module.exports = __webpack_public_path__ + "static/Apercu-BoldItalic-1ef69c629e15128b9e8b054014cf6bfb.ttf";